import axios from "axios";
import { Toast } from "../../util/Toast";
import {
  CLOSE_GHOST_ACCOUNT_DIALOG,
  CREATE_GHOST_ACCOUNT,
  DELETE_GHOST_ACCOUNT,
  GET_GHOST_ACCOUNT,
  UPDATE_GHOST_ACCOUNT_STATUS,
} from "./types";

export const getGhostAccount = () => (dispatch) => {
  axios
    .get(`ghostAccount`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_GHOST_ACCOUNT, payload: res.data.ghostAccounts });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const createGhostAccount = (data) => (dispatch) => {
  axios
    .post(`ghostAccount`, data)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Ghost account created successfully!");
        dispatch({ type: CLOSE_GHOST_ACCOUNT_DIALOG });
        dispatch({
          type: CREATE_GHOST_ACCOUNT,
          payload: res.data.ghostAccount,
        });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => Toast("error", error.message));
};

export const updateGhostAccountStatus =
  (ghostAccountId, isActive) => (dispatch) => {
    axios
      .post(`ghostAccount/${ghostAccountId}/status`, { isActive })
      .then((res) => {
        console.log("res", res);
        if (res.data.status) {
          Toast("success", "Ghost account status updated successfully!");
          dispatch({
            type: UPDATE_GHOST_ACCOUNT_STATUS,
            payload: { data: res.data.ghostAccount, id: ghostAccountId },
          });
        } else {
          Toast("error", res.data.message);
          console.log("error", res.data.message);
        }
      })
      .catch((error) => Toast("error", error.message));
  };

export const deleteGhostAccount = (ghostAccountId) => (dispatch) => {
  axios
    .delete(`ghostAccount/${ghostAccountId}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: DELETE_GHOST_ACCOUNT, payload: ghostAccountId });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};
